import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { Badges as B } from './Badges';

export const Badges = compose(injectIntl)(B);
